export default "__VITE_ASSET__BnPznWUc__"